import React, { useState } from 'react';
import { Session } from './types';
import HomeScreen from './screens/HomeScreen';
import JoinScreen from './screens/JoinScreen';
import WaitingScreen from './screens/WaitingScreen';
import SwipeScreen from './screens/SwipeScreen';
import FinishedWaitingScreen from './screens/FinishedWaitingScreen';
import ResultsScreen from './screens/ResultsScreen';

type Screen =
  | 'home'
  | 'join'
  | 'waiting'
  | 'swiping'
  | 'finished-waiting'
  | 'results';

const App: React.FC = () => {
  const [screen, setScreen] = useState<Screen>('home');
  const [sessionCode, setSessionCode] = useState('');
  const [userName, setUserName] = useState('');
  const [user, setUser] = useState<'userA' | 'userB'>('userA');
  const [session, setSession] = useState<Session | null>(null);

  const handleSessionCreated = (code: string, name: string, u: 'userA') => {
    setSessionCode(code);
    setUserName(name);
    setUser(u);
    setScreen('waiting');
  };

  const handlePartnerJoined = (s: Session) => {
    setSession(s);
    setScreen('swiping');
  };

  const handleSessionJoined = (code: string, name: string, u: 'userB', s: Session) => {
    setSessionCode(code);
    setUserName(name);
    setUser(u);
    setSession(s);
    setScreen('swiping');
  };

  const handleFinishedSwiping = () => {
    setScreen('finished-waiting');
  };

  const handleBothFinished = (s: Session) => {
    setSession(s);
    setScreen('results');
  };

  return (
    <div className="bg-dinder-dark" style={{ minHeight: '100vh' }}>
      {screen === 'home' && (
        <HomeScreen
          onSessionCreated={handleSessionCreated}
          onJoinSession={() => setScreen('join')}
        />
      )}
      {screen === 'join' && (
        <JoinScreen
          onSessionJoined={handleSessionJoined}
          onBack={() => setScreen('home')}
        />
      )}
      {screen === 'waiting' && (
        <WaitingScreen
          sessionCode={sessionCode}
          userName={userName}
          onPartnerJoined={handlePartnerJoined}
        />
      )}
      {screen === 'swiping' && session && (
        <SwipeScreen
          session={session}
          sessionCode={sessionCode}
          user={user}
          userName={userName}
          onFinished={handleFinishedSwiping}
        />
      )}
      {screen === 'finished-waiting' && (
        <FinishedWaitingScreen
          sessionCode={sessionCode}
          userName={userName}
          onBothFinished={handleBothFinished}
        />
      )}
      {screen === 'results' && session && (
        <ResultsScreen
          session={session}
          userName={userName}
        />
      )}
    </div>
  );
};

export default App;